import { render, staticRenderFns } from "./ProjectDocumentDetailsNewForm.vue?vue&type=template&id=8d6e39d4&"
import script from "./ProjectDocumentDetailsNewForm.vue?vue&type=script&lang=js&"
export * from "./ProjectDocumentDetailsNewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports